module.exports = __webpack_public_path__ + "img/bg.c0749cf4.jpg";